import React, { useState } from "react";

const links = [
  { label: "About", href: "#about" },
  { label: "Packages", href: "#packages" },
  { label: "Process", href: "#process" },
  { label: "Enquire", href: "#enquire" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  return (
    <nav data-testid="main-nav" className="nav-bar">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-logo" className="flex items-baseline">
          <span className="font-serif-display text-xl font-semibold text-[color:var(--charcoal)]" style={{ letterSpacing: "0.08em" }}>
            THE FOUNDATION EDIT
          </span>
        </a>
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="nav-link"
            >
              {l.label}
            </a>
          ))}
          <a href="#enquire" data-testid="nav-cta" className="btn-primary" style={{ padding: "0.7rem 1.4rem" }}>
            Apply to Work Together
          </a>
        </div>
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden nav-link"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[color:var(--border-light)] bg-[color:var(--bg-base)]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="nav-link"
                data-testid={`mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
